module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.2dccaa62ec1cd6a57d39.js");
};